import React from "react";
import { cn } from "@/utils";
import SvgIcon from "../svg-icons";

interface ChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  showChip?: boolean;
}

const Chip: React.FC<ChipProps> = ({
  selected = false,
  showChip = false,
  className,
  children,
  ...props
}) => {
  return (
    <button
      className={cn(
        "px-3 py-1 border rounded-full mb-3 mr-3",
        selected ? "bg-emerald-100 border-primary" : "bg-emerald-50 border-dark",
        className
      )}
      {...props}
    >
      {showChip && selected && <SvgIcon className="inline-block mr-2 text-primary" name="check" />}
      {children}
    </button>
  );
};

export default Chip;
